import React, { useEffect, useState } from "react";
import {
  Typography,
  Input,
  Modal,
  Button,
  Popover,
  Layout,
  Skeleton,
  Table,
  Select,
  Pagination,
  DatePicker,
  message as messageApi,
} from "antd";
import dayjs from "dayjs";
import { FaSearch, FaFilter, FaEye, FaPlus, FaChalkboardTeacher } from "react-icons/fa";
import { Get } from "../../config/api/get";
import { COURSE, LECTURES } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";

const { Option } = Select;

function LectureManagement() {
  const token = useSelector((state) => state.user.userToken);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [categories] = useState([]); // eslint-disable-line no-unused-vars
  const [selectedUser, setSelectedUser] = useState(null); // eslint-disable-line no-unused-vars
  const [lectures, setLectures] = useState([]);
  const [paginationConfig, setPaginationConfig] = useState({
    pageNumber: 1,
    limit: 10,
    totalDocs: 0,
    totalPages: 0,
  });
  const navigate = useNavigate();

  const [filter, setFilter] = useState({
    status: null,
    keyword: "",
    from: null,
    to: null,
  });

  const startIndex =
    (paginationConfig.pageNumber - 1) * paginationConfig.limit + 1;
  const endIndex = Math.min(
    startIndex + paginationConfig.limit - 1,
    paginationConfig.totalDocs
  );
  const recordsMessage = `Showing records ${endIndex} of ${paginationConfig.totalDocs}`;

  useEffect(() => {
    getLectures();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handlePageChange = (pageNumber) => {
    setPaginationConfig({
      ...paginationConfig,
      pageNumber: pageNumber,
    });

    getLectures(pageNumber);
  };

  const handleSearch = (value) => {
    setFilter({
      ...filter,
      keyword: value,
    });
  };

  const handleStatusChange = (value) => {
    setFilter({
      ...filter,
      category: value,
    });
  };

  const resetFilter = () => {
    setFilter({
      category: "",
      keyword: "",
      from: null,
      to: null,
    });
    getLectures(paginationConfig.pageNumber, paginationConfig.limit, "", true);
  };

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen);
  };

  const handleFrom = (date) => {
    setFilter({
      ...filter,
      from: date,
    });
  };

  const handleTo = (date) => {
    setFilter({
      ...filter,
      to: date,
    });
  };

  const handleLimitChange = (pageSize) => {
    setPaginationConfig({
      ...paginationConfig,
      limit: pageSize,
      current: 1,
    });

    getLectures(1, pageSize);
  };

  const handleStatus = async () => {
    try {
      const index = lectures.findIndex((user) => user._id === selectedUser._id);

      console.log(index);
      await Get(
        COURSE.toggleStatus + "/" + selectedUser._id,
        token,
        {}
      );
      const newUsers = [...lectures];

      console.log(">>>>", newUsers[index].isActive);
      console.log(">>>>", selectedUser.isActive);
      newUsers[index].isActive = !selectedUser.isActive;
      setModalOpen(false);
      setLectures(newUsers);
    } catch (error) {
      console.log(error.message);
    }
  };

  const getLectures = async (pageNumber, pageSize, search, reset = false) => {
    setLoading(true);
    try {
      const response = await Get(LECTURES.getAllLectures, token, {
        page: pageNumber
          ? pageNumber.toString()
          : paginationConfig.pageNumber.toString(),
        limit: pageSize
          ? pageSize.toString()
          : paginationConfig.limit.toString(),
        category: reset ? "" : filter.category || null,
        keyword: search ? search : null,
        from: reset ? "" : filter?.from ? filter?.from.toISOString() : "",
        to: reset ? "" : filter?.to ? filter?.to.toISOString() : "",
      });
      setLoading(false);
      console.log("response", response);
      if (response?.data?.docs) {
        setLectures(response?.data?.docs);
        setPaginationConfig({
          pageNumber: response?.data?.page,
          limit: response?.data?.limit,
          totalDocs: response?.data?.totalDocs,
          totalPages: response?.data?.totalPages,
        });
      } else {
        messageApi.error("Something went wrong!");
        console.log("error====>", response);
      }
    } catch (error) {
      console.log(error.message);
      setLoading(false);
    }
  };

  console.log("paginationConfig", paginationConfig);

  const itemRender = (_, type, originalElement) => {
    if (type === "prev") {
      return (
        <button type="button" className="cm-pager-btn">
          Previous
        </button>
      );
    }
    if (type === "next") {
      return (
        <button type="button" className="cm-pager-btn">
          Next
        </button>
      );
    }
    return originalElement;
  };

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      width: 70,
      render: (value, item, index) => (
        <span className="cm-index">{(index < 9 ? "0" : "") + (index + 1)}</span>
      ),
    },
    {
      title: "lecture No",
      dataIndex: "lectureNo",
      key: "lectureNo",
      render: (val) => <span className="cm-code">{val}</span>,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (title) => (
        <span className="cm-title-cell" title={title}>
          {title}
        </span>
      ),
    },
    {
      title: "Course",
      dataIndex: "course",
      key: "course",
      render: (item) => (
        <span className="cm-category-cell" title={item?.title}>
          {item?.title}
        </span>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      render: (item) => (
        <span className="cm-category-cell" title={item?.title}>
          {item?.title}
        </span>
      ),
    },
    {
      title: "Created At",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (item) => (
        <span className="cm-meta-cell">{dayjs(item).format("M/D/YYYY")}</span>
      ),
    },
    {
      title: "Action",
      dataIndex: "_id",
      key: "_id",
      width: 90,
      render: (item) => (
        <button
          type="button"
          className="cm-view-btn"
          aria-label="View lecture"
          onClick={() => navigate("/lecture-details/" + item)}
        >
          <FaEye aria-hidden="true" />
        </button>
      ),
    },
  ];

  const filterContent = (
    <div className="filterDropdown cm-filter-popover">
      <p className="cm-filter-head">Filter lectures</p>
      <hr />

      <div className="filterDropdownBody">
        <p className="mainLabel">Start Date:</p>
        <DatePicker
          className="mainInput filterInput"
          value={filter.from}
          onChange={(e) => handleFrom(e)}
        />
        <DatePicker
          className="mainInput filterInput"
          value={filter.to}
          onChange={(e) => handleTo(e)}
        />

        <p className="mainLabel">Filter by Category:</p>

        <Select
          size={"large"}
          className="filterSelectBox cm-filter-select"
          placeholder="Select Category"
          value={filter.category}
          onChange={(e) => handleStatusChange(e)}
        >
          {categories.map((item) => (
            <Option key={item._id} value={item._id}>
              {item?.title}
            </Option>
          ))}
        </Select>

        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton cm-filter-apply"
          onClick={() => getLectures()}
        >
          Apply
        </Button>
        <Button
          type="primary"
          block
          size={"large"}
          className="loginButton"
          onClick={() => resetFilter()}
        >
          Clear All
        </Button>
      </div>
    </div>
  );

  return (
    <Layout className="cm-page">
      <section
        className="cm-hero"
        style={{
          backgroundImage: `url(${ImageUrl("coursesbnr.png")})`,
        }}
      >
        <div className="cm-hero-overlay" aria-hidden />
        <div className="cm-wrap cm-hero-inner">
          <div className="cm-hero-copy">
            <span className="cm-hero-badge">LECTURE MANAGEMENT</span>
            <h1 className="fontFamily1 cm-hero-title">
              Manage Lectures. <span>Empower Learning.</span>
            </h1>
            <p className="fontFamily1 cm-hero-sub">
              Create, organize and update lectures for your courses in one
              place.
            </p>
            <div className="cm-hero-actions">
              <Button
                type="primary"
                size="large"
                className="cm-hero-btn-primary"
                onClick={() => navigate("/lecture-details/add")}
              >
                <span className="cm-hero-btn-plus">
                  <FaPlus />
                </span>
                Add Lecture
              </Button>
            </div>
          </div>
        </div>
      </section>

      <div className="cm-wrap cm-main">
        <div className="cm-panel">
          <div className="cm-toolbar">
            <div className="cm-toolbar-intro">
              <span className="cm-toolbar-icon" aria-hidden>
                <FaChalkboardTeacher />
              </span>
              <h2 className="fontFamily1">Lecture Management</h2>
            </div>
            <div className="cm-toolbar-actions">
              <Button
                type="primary"
                className="cm-btn-course"
                onClick={() => navigate("/lecture-details/add")}
              >
                Add Lecture
              </Button>
            </div>
          </div>

          <div className="cm-sub-toolbar">
            <div className="cm-page-size">
              <span>Show</span>
              <Select
                size={"large"}
                className="cm-limit-select"
                defaultValue={paginationConfig.limit}
                onChange={(e) => handleLimitChange(e)}
                options={[
                  { value: 10, label: "10" },
                  { value: 20, label: "20" },
                  { value: 30, label: "30" },
                  { value: 40, label: "40" },
                  { value: 50, label: "50" },
                ]}
              />
              <span>entries</span>
            </div>
            <div className="cm-search-row">
              <Popover
                content={filterContent}
                trigger="click"
                open={open}
                onOpenChange={handleOpenChange}
                placement="bottomRight"
                arrow={false}
              >
                <Button className="cm-filter-trigger" aria-label="Open filters">
                  <FaFilter />
                </Button>
              </Popover>
              <div className="cm-search-wrap">
                <Input
                  className="cm-search"
                  placeholder="Search lectures..."
                  value={filter.keyword}
                  onChange={(e) => handleSearch(e.target.value)}
                  onPressEnter={() =>
                    getLectures(1, paginationConfig.limit, filter.keyword)
                  }
                />
                <button
                  type="button"
                  className="cm-search-btn"
                  aria-label="Search lectures"
                  onClick={() =>
                    getLectures(1, paginationConfig.limit, filter.keyword)
                  }
                >
                  <FaSearch />
                </button>
              </div>
            </div>
          </div>

          {loading ? (
            <div className="cm-skeleton">
              <Skeleton active paragraph={{ rows: 6 }} />
            </div>
          ) : (
            <div className="cm-table-wrap">
              <Table
                className="cm-table"
                dataSource={lectures}
                columns={columns}
                pagination={false}
                rowKey={(record, index) =>
                  record._id ?? `lecture-row-${index}`
                }
                scroll={{ x: "max-content" }}
              />
            </div>
          )}

          <div className="cm-pagination-row">
            <p className="fontFamily1 cm-pagination-meta">{recordsMessage}</p>
            <Pagination
              className="styledPagination cm-pagination"
              onChange={(e) => handlePageChange(e)}
              current={parseInt(paginationConfig.pageNumber)}
              pageSize={paginationConfig.limit}
              total={paginationConfig.totalDocs}
              itemRender={itemRender}
            />
          </div>
        </div>
      </div>

      <Modal
        visible={modalOpen}
        onOk={() => handleStatus()}
        onCancel={() => setModalOpen(false)}
        okText="Yes"
        className="StyledModal"
        style={{
          left: 0,
          right: 0,
          marginLeft: "auto",
          marginRight: "auto",
          textAlign: "center",
        }}
        cancelText="No"
        cancelButtonProps={{
          style: {
            border: "2px solid #2484c6",
            color: "#2484c6",
            height: "auto",
            padding: "6px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            marginTop: "15px",
          },
        }}
        okButtonProps={{
          style: {
            backgroundColor: "#2484c6",
            color: "white",
            marginTop: "15px",
            height: "auto",
            padding: "5px 35px",
            borderRadius: "50px",
            fontSize: "16px",
            border: "2px solid #2484c6",
          },
        }}
      >
        <Typography.Title level={4} style={{ fontSize: "25px" }}>
          {selectedUser?.isActive ? "Deactivate" : "Activate"}
        </Typography.Title>
        <Typography.Text style={{ fontSize: 16 }}>
          Do You Want To {selectedUser?.isActive ? "Deactivate" : "Activate"}{" "}
          This Service Provider?
        </Typography.Text>
      </Modal>
    </Layout>
  );
}

export default LectureManagement;
